/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Origin_StoryInputs */

const en_road_dude_origin_story = /** @type {(inputs: Road_Dude_Origin_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The meme began with a fishing-spot video posted by Bird28thegr8 in August 2025. A pickup driver questions the anglers, who thought the pond was on state land. The driver pauses in disbelief and tells them it’s private property.`)
};

const zh_road_dude_origin_story = /** @type {(inputs: Road_Dude_Origin_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个梗来自 Bird28thegr8 在 2025 年 8 月发布的钓鱼视频。钓鱼人以为池塘属于公共土地，皮卡司机听到后愣了一下，告诉他们这里是私人领地。`)
};

/**
* | output |
* | --- |
* | "The meme began with a fishing-spot video posted by Bird28thegr8 in August 2025. A pickup driver questions the anglers, who thought the pond was on state land..." |
*
* @param {Road_Dude_Origin_StoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_origin_story = /** @type {((inputs?: Road_Dude_Origin_StoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Origin_StoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_origin_story(inputs)
	return zh_road_dude_origin_story(inputs)
});
export { road_dude_origin_story as "road_dude.origin.story" }